module.exports = __webpack_public_path__ + "img/wireSpool.41344226.webp";